<template>
  <div class="ui fixed inverted menu">
    <div class="ui container">
      <a href="" class="header item">
        <img src="" alt="" class="logo">plab
      </a>
      <a href="" class="item">Home</a>
    </div>
  </div>
</template>
<style>
  .ui.menu .item img.logo {
    margin-right: 1.5em;
  }
</style>

<script>
export default {
  name: 'header'
}
</script>




// WEBPACK FOOTER //
// src/components/header.vue